import React, { useEffect, useState } from 'react'
import { getApiUrl } from '../../config/api'

const ADMIN_KEY = 'persona-admin-2024'

const AdminSettingsPage = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [settings, setSettings] = useState({
    companionVisible: true,
    recommendedSpheresVisible: true,
  })

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true)
        setError('')
        const res = await fetch(getApiUrl(`/api/admin/settings?adminKey=${ADMIN_KEY}`))
        const data = await res.json()
        if (!res.ok) throw new Error(data.error || '설정 로드 실패')
        const cfg = {
          companionVisible: !!data.settings?.companion_visible,
          recommendedSpheresVisible: !!data.settings?.recommended_spheres_visible,
        }
        setSettings(cfg)
        // 캐시 업데이트 (홈에서 즉시 반영)
        localStorage.setItem('admin_ui_settings_cache', JSON.stringify(cfg))
      } catch (e) {
        setError(e.message)
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [])

  const persist = async (next) => {
    setSettings(next)
    try {
      setLoading(true)
      setError('')
      setSuccess('')
      const res = await fetch(getApiUrl('/api/admin/settings'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          adminKey: ADMIN_KEY,
          companionVisible: next.companionVisible,
          recommendedSpheresVisible: next.recommendedSpheresVisible,
        })
      })
      const data = await res.json()
      if (!res.ok || !data.success) throw new Error(data.error || '설정 저장 실패')
      setSuccess('설정을 저장했습니다.')
      // 캐시 업데이트 (홈에서 즉시 반영)
      localStorage.setItem('admin_ui_settings_cache', JSON.stringify(next))
    } catch (e) {
      setError(e.message)
    } finally {
      setLoading(false)
    }
  }

  const handleToggle = (key) => {
    setSuccess('')
    setError('')
    persist({ ...settings, [key]: !settings[key] })
  }

  return (
    <div className="admin-settings">
      <div className="admin-header">
        <h1>⚙️ 기타 설정</h1>
        <p>관리자 전용 UI 요소 노출을 제어합니다.</p>
      </div>

      {error && (
        <div className="error-section">
          <h3>❌ 오류</h3>
          <pre className="error-message">{error}</pre>
        </div>
      )}
      {success && (
        <div className="success-section">
          <h3>✅ 완료</h3>
          <pre className="success-message">{success}</pre>
        </div>
      )}

      <div className="card">
        <div className="toggle-item">
          <label>
            <input type="checkbox" checked={settings.companionVisible} onChange={() => handleToggle('companionVisible')} />
            컴패니언 위젯 표시(관리자만)
          </label>
        </div>
        <div className="toggle-item">
          <label>
            <input type="checkbox" checked={settings.recommendedSpheresVisible} onChange={() => handleToggle('recommendedSpheresVisible')} />
            추천 스피어 표시(관리자만)
          </label>
        </div>
      </div>

      <p className="help-text">이 설정은 DB `admin_settings` 테이블에 저장됩니다.</p>
    </div>
  )
}

export default AdminSettingsPage


